import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Divider, Skeleton, Avatar, Space, Row, Col, Alert } from "antd";
import { UserOutlined, SettingOutlined } from "@ant-design/icons";
import moment from "moment-jalaali";
import CardForm from "./cardForm";

function CardDetails({ id, onDataUpdate, onCloseDrawer }) {
  const GETCARD = gql`
    query ($id: ID!) {
      getCard(id: $id) {
        createdAt
        updatedAt
        cardNo
        cardIdentifier
        deliveredAt
        deactivatedAt
        contract
        user {
          id
          name
          mobile
          profileImg
        }
        issuedAt
        description
        cardStatus
      }
    }
  `;
  const [initialData, setInitialData] = useState({});
  const [formData, setFromData] = useState(null);
  const [getCardData, cardData] = useLazyQuery(GETCARD, {

    
    fetchPolicy: "no-cache",
    onCompleted({ getCard }) {
      const cardData = {
        deliveredAt: getCard?.deliveredAt && moment(getCard?.deliveredAt),
        cardNo: getCard?.cardNo,
        cardIdentifier: getCard?.cardIdentifier,
        description: getCard?.description,
        cardStatus: getCard?.cardStatus,
        deactivatedAt : getCard?.deactivatedAt,
        contract: getCard?.contract
      };
      setFromData(cardData);
      const { createdAt, description, user, cardStatus, issuedAt } = getCard;
      setInitialData({
        description,
        user,
        cardStatus,
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        issuedAt: issuedAt && moment(issuedAt).format("jYYYY/jMM/jDD"),
      });
    },
  });
  useEffect(() => {
    if (id) {
      getCardData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const { user, createdAt, cardStatus, issuedAt, deactivatedAt } = initialData;

  if (cardData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <>
      <Row>
        <Col sm={12} xs={24}>
          <Space>
            <Avatar src={user?.profileImg} icon={<UserOutlined />} />
            {user?.name} -{user?.mobile}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>وضعیت: </p>
            {cardStatus === "ISSUING"
              ? "پرداخت شده - در انتظار صدور"
              : cardStatus === "DELIVERING"
              ? "صادر شده - در انتظار تحویل"
              : "تحویل داده شده"}
          </Space>
        </Col>
      </Row>
      <Divider style={{ fontWeight: 700 }} orientation="right">
        اطلاعات کارت
      </Divider>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ درخواست: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          {issuedAt && (
            <Space align="">
              <p>تاریخ ثبت: </p>
              {issuedAt}
            </Space>
          )}
        </Col>
      </Row>

      <CardForm
        formData={formData}
        onDoUpdateData={onDataUpdate}
        onDoCloseDrawer={onCloseDrawer}
        id={id}
        userId={user?.id}
      />
    </>
  );
}

export default CardDetails;
